import React from "react";

export function LogoBadge({ label, className = "" }) {
  return (
    <span
      className={`inline-flex items-center justify-center px-2.5 py-1 border border-border rounded-md text-xs font-bold tracking-wider text-foreground/80 bg-background/60 ${className}`}
    >
      {label}
    </span>
  );
}

export function LogoCluster() {
  return (
    <div className="flex items-center gap-2">
      <LogoBadge label="USK" />
      <LogoBadge label="BRIN" />
      <LogoBadge label="UTU" />
    </div>
  );
}
